import { renderSections } from "../utils/renderSections";

export default {
	requests: new Set(),
	isUpdating: false,
	isOpen: false,

	// Get the section ids from the sections to be re-rendered when the cart updates.
	getSectionIDs() {
		return [...document.querySelectorAll("[data-cart-section]")].map(
			(el) => el.dataset.id
		);
	},

	// Render cart-related sections.
	render(sections) {
		return renderSections(sections);
	},

	// Send data to a cart AJAX endpoint.
	async send(endpoint, data) {
		this.requests.add(data);
		this.isUpdating = this.requests.size > 0;

		const config = {
			method: "POST",
		};
		const sectionIDs = this.getSectionIDs();

		if (data instanceof FormData) {
			data.append("sections", sectionIDs.join(","));
			data.append("sections_url", window.location.pathname);

			config.body = data;
		} else {
			config.headers = {
				"Content-Type": "application/json",
				Accept: "application/json",
			};

			config.body = JSON.stringify({
				...data,
				sections: sectionIDs,
				sections_url: window.location.pathname,
			});
		}

		let succeeded = false;

		try {
			const response = await fetch(
				`${window.Shopify.routes.root}cart/${endpoint}`,
				config
			);
			const json = await response.json();

			if (!response.ok) {
				throw new Error(json.message);
			}

			await this.render(json.sections);

			succeeded = true;
		} catch (error) {
			console.error(error);
		}

		this.requests.delete(data);
		this.isUpdating = this.requests.size > 0;

		return succeeded;
	},

	// https://shopify.dev/api/ajax/reference/cart#post-locale-cart-add-js
	// Will accept an array of item(s), or a FormData object.
	add(items = []) {
		return this.send("add.js", items).then((result) => {
			this.isOpen = true;
			return result;
		});
	},

	// https://shopify.dev/docs/api/ajax/reference/cart#post-locale-cart-update-js
	// Best for updating the cart note or cart attributes.
	update(update = {}) {
		return this.send("update.js", update);
	},

	// https://shopify.dev/api/ajax/reference/cart#post-locale-cart-change-js
	// Best for updating quantities, properties, or selling_plans of line items.
	change(update = {}) {
		return this.send("change.js", update);
	},

	
};
